import World from '../../src/legacy/World.tsx';
export default World;
